import React from "react";
import { Link } from "react-router-dom";
import ravenQuote from "../../Raven404Page.webp";

class NotFound extends React.Component {
  render() {
    return (
      <>
        <div className="app">
          <div className="container top">
            <h1>Page not found: 404</h1>
            <Link to="/">
              <img src={ravenQuote}  />
            </Link>
          </div>
        </div>
      </>
    );
  }
}

export default NotFound;
